<template>
    <graph ref="chart" :chart-data="chart_data" />
</template>

<script type="text/javascript">
import graph_component from "./GraphComponent"

import Graph from "./ProspectiveStatiiGraph.js"

export default {
    mixins: [graph_component],
    components: {
        Graph
    },
    computed: {
        chart_data () {
            const chart_data = {
                labels: [],
                datasets: [{ backgroundColor: [], data: [], _total: 0 }]
            }
            this.rawData.filter(status => !!status.count).forEach((status, index) => {
                chart_data.labels.push(status.name)
                let color_name = status.id.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase()
                color_name = `color_${color_name}`
                if(this[color_name]) chart_data.datasets[0].backgroundColor.push(this[color_name].background)
                chart_data.datasets[0].data.push(status.count)
                chart_data.datasets[0]._total += status.count
            })

            return chart_data
        }
    }
}
</script>
